import './TwoColSection.css'
const TwoColSection = (props)=>{
    const leftAnim = props.leftAnimation;
    const rightAnim = props.rightAnimation;
    const leftShould = leftAnim && leftAnim.animationType && leftAnim.animationType !== 'none';
    const rightShould = rightAnim && rightAnim.animationType && rightAnim.animationType !== 'none';
    return(
        <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 TwoColSectionText" {...(rightShould ? {
                    'data-aos': rightAnim.animationType,
                    'data-aos-duration': Number(rightAnim.animationDuration),
                    'data-aos-delay': Number(rightAnim.animationDelay),
                } : {})}>
                    <h2>{props.title}</h2>
                    <span>{props.text}</span>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 Center" {...(leftShould ? {
                    'data-aos': leftAnim.animationType,
                    'data-aos-duration': Number(leftAnim.animationDuration),
                    'data-aos-delay': Number(leftAnim.animationDelay),
                } : {})}>
                    <img src={props.image} width="100%" alt="" />
                </div>
            </div>
        </div>
    );
}
export default TwoColSection;